import { useDispatch, useSelector } from 'react-redux';
import useHasAccessToAirAmbulance from '@rsos/hooks/useHasAccessToAirAmbulance';
import {
  setSelectedTool,
  setSelectedTab,
} from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import {
  OVERVIEW_TAB,
  AIR_AMBULANCE_TOOL,
  TOOLS_TAB,
} from '@rsos/reduxDataStore/src/features/eventPane/eventPaneTabs';
import { getMostRecentLoc } from '@rsos/utils/getMostRecentLoc';
import isValidCoordinates from '@rsos/utils/isValidCoordinates';
import {
  trackRequestAirAmbulanceClick,
  AIR_AMBULANCE_SOURCE_BUTTON,
} from '../../../../../gainsightTrackings/airAmbulanceTrackings';
import AdrQueryContainer from '../../../../AdditionalData/AdrQuery/AdrQueryContainer';
import MediaUniteEventPane from '../../../../AdditionalData/Media/MediaUniteEventPane';
import MostRecentLocationCard from '../../../../MostRecentLocationCard';
import AirAmbulanceCard from '../../AirAmbulance';
import ChatCard from '../../ChatCard';
import EventShareCard from '../../EventShareCard/EventShareCard';
import DataCardsSummary from '../DataCardsSummary';
import OverviewBanners from './OverviewBanners';
import { OverviewTabContent } from './OverviewTab.styles';

/**
 * The Overview tab of the EventPane
 */
const OverviewTab = ({ onDataCardClick, callerID }) => {
  const hasAccessToAirAmbulance = useHasAccessToAirAmbulance();

  const selectedCall = useSelector(
    state => state.emergencyCalls?.callQueue?.[callerID],
  );

  const mostRecentLoc = getMostRecentLoc(selectedCall);
  const hasLocationToRender = isValidCoordinates(mostRecentLoc);

  const dispatch = useDispatch();
  const handleAirAmbulance = () => {
    dispatch(setSelectedTab(TOOLS_TAB));
    dispatch(setSelectedTool({ tool: AIR_AMBULANCE_TOOL }));
    trackRequestAirAmbulanceClick({
      sourceButton: AIR_AMBULANCE_SOURCE_BUTTON.OVERVIEW_TAB,
    });
  };

  return (
    <>
      <OverviewTabContent horizontal>
        <OverviewBanners />
        <AdrQueryContainer />
        {!selectedCall?.isAdmin && hasLocationToRender && (
          <MostRecentLocationCard />
        )}
        <DataCardsSummary onDataCardClick={onDataCardClick} />
        <EventShareCard />
        <ChatCard />
        <MediaUniteEventPane />
        {hasAccessToAirAmbulance && (
          <AirAmbulanceCard
            tab={OVERVIEW_TAB}
            handleClick={handleAirAmbulance}
          />
        )}
      </OverviewTabContent>
    </>
  );
};

export default OverviewTab;
